export default __webpack_public_path__ + "static/media/daviplata.2c6c0452.svg";